import { runVersionGuard } from './versionGuard';
import { startVersionPoll } from './versionPoll';
import { watchPreloadErrors } from './preloadErrorGuard';

/**
 * Keeps a tab in sync with the deployed build: resets+reloads on a stale
 * version at startup, polls for later deploys while the tab stays open, and
 * recovers from a lazy-chunk 404 in the gap between the two.
 */
export function initDeployGuards(): void {
	runVersionGuard();
	startVersionPoll();
	watchPreloadErrors();
}
